@defer {
  <div punchout-name>
    <span name>{{ name() }}</span>
  </div>
  <div punchout-account>
    <span customer-number>{{ customerNumber() }}</span
    ><span divider> - </span><span customer-name>{{ customerName() }}</span>
  </div>
}
